import { Box, Paper, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { Loading } from '../../../components/UI'
import { Status } from '../../../hooks/useFetchState'
import { getInventoryCheckDetail} from '../api'
import {  InventoryCheckDetail, InventoryCheckEntity } from '../entities/InventoryCheck'
import { useApi } from '../../../hooks/useApi'
import { GenericTable } from '../../../components/_EOS/Table'
import { generateTableHeadersInventoryCheckDetail } from '..'
import { Modal } from '../../../components/_EOS/Modal'
import { useModal } from '../../../hooks/useModal'
import { ChangeUserInventoryCheckModal } from './ChangeUserInventoryCheckModal'

interface ReassignInventoryCheckModalProps {
  inventoryCheckId: number
  handleCloseModal: () => void
  handleSnackbar: (message: string, success: boolean) => void
}

export const ReassignInventoryCheckModal: React.FC<ReassignInventoryCheckModalProps> =
  ({ inventoryCheckId, handleSnackbar }) => {
    // con el id, vamos a buscar los usuarios asociados al ciclico
    // usamore useApi

    const [loading, setLoading] = useState<boolean>(false)
    const { state, callApi } = useApi<InventoryCheckEntity>()
    const tableHeadersInventoryCheckDetail = generateTableHeadersInventoryCheckDetail()

    const editUserModalState = useModal<{
        id: number
      }>('')

    const requestInventoryCheckDetail = (pInventoryCheckId:number) => {
        setLoading(true)
        callApi(getInventoryCheckDetail(pInventoryCheckId))
          .then(() => {
            setLoading(false)
          })
          .catch((error) => {
            handleSnackbar(error, false)
          })
        setLoading(false)
      }

      useEffect(() => {
        requestInventoryCheckDetail(inventoryCheckId)
      }, [])

    if (state.status === Status.Loading || loading) {
      return (
        <div>
          <Typography>
            <Loading />
          </Typography>
        </div>
      )
    } else {
    return (
        <Fragment>
            <Typography>Detalle</Typography>
                <Box overflow={'auto'} maxHeight={'250px'} component={Paper}>
                  <GenericTable<InventoryCheckDetail>
                    headersConfig={tableHeadersInventoryCheckDetail}
                    data={state.data?.details.filter(f=> !f.endDate)}//solo las que no esten finalizadas
                    IDKey={'inventoryCheckDetailId'}
                    noResultsText='No existe información'
                    isLoading={loading}
                    actions={{
                        onEdit: (row) => {editUserModalState.openModal('sm', {id: row}, 'Editar Usuarios')},
                      }}
                  />
                </Box>
                <Modal
                  open={editUserModalState.isOpen}
                  title={editUserModalState.title}
                  maxWidth={editUserModalState.size}
                  onClose={editUserModalState.closeModal}
                  cancelButton={{
                    action: editUserModalState.closeModal,
                    title: 'Salir'
                  }}
                >
                  <Fragment>
                    <ChangeUserInventoryCheckModal inventoryCheckDetailId={editUserModalState.extendedProps?.id as number}
                      handleCloseModal={editUserModalState.closeModal}
                      handleSnackbar={handleSnackbar}
                      inventoryCheckId={inventoryCheckId}
                      requestInventoryCheckDetail={requestInventoryCheckDetail}/>
                  </Fragment>
                </Modal>
        </Fragment>

    )}
  }
